export default __webpack_public_path__ + "static/pitch-sans-web-bold-45b6e413ac490fa8dd510f29e1db17d8.woff2";